"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "py-4 pr-4" };
const _hoisted_2 = { class: "line-clamp-2" };
const vue_3 = require("vue");
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const services_constants_1 = require("@ocm/services/services.constants");
const TOAST_DURATION = 4000;
const TOAST_LEAVE_DURATION = 360;
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedToast',
    setup(__props) {
        const _createUuid = () => (Math.random() + 1).toString(36).substring(2);
        const _icons = new Map([
            ["default", "checkmark-circled"],
            ["info", "info"],
            ["wishlist", "heart-filled"],
        ]);
        let _toast = null;
        const toast = (0, vue_3.ref)();
        const _addToast = ({ data }) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            _toast = Object.assign(Object.assign({ id: _createUuid() }, data), { icon: _icons.get((_a = data.type) !== null && _a !== void 0 ? _a : "default") });
            // remove existing toast
            if (toast.value) {
                toast.value = undefined;
                yield new Promise((resolve) => setTimeout(resolve, TOAST_LEAVE_DURATION));
            }
            toast.value = _toast;
            const id = _toast.id;
            setTimeout(() => {
                if ((_toast === null || _toast === void 0 ? void 0 : _toast.id) !== id)
                    return;
                _removeToast();
            }, TOAST_DURATION);
        });
        const _removeToast = () => {
            _toast = null;
            toast.value = undefined;
        };
        (0, vue_3.onMounted)(() => {
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.ADD_TOAST, _addToast);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#shared-toast-container" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "shared-toast" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (toast.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "shared-toast ocm-body1 grid max-w-96 grid-cols-[4rem,1fr] gap-x-1 justify-self-center rounded-lg bg-gray-beton",
                                style: (0, vue_2.normalizeStyle)({ '--toast-leave-duration': TOAST_LEAVE_DURATION })
                            }, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["grid items-center rounded-l-lg pl-3", toast.value.type === 'info' ? 'diagonal-info' : 'diagonal-success'])
                                }, [
                                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                        class: (0, vue_2.normalizeClass)(toast.value.type === 'wishlist' ? 'size-5' : 'size-4.5'),
                                        "icon-name": toast.value.icon
                                    }, null, 8, ["class", "icon-name"])
                                ], 2),
                                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(toast.value.message), 1)
                                ])
                            ], 4))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
